import React from 'react';


export default function SettingDisplayPaymentMethod({value}) {
    if (!value || !value.channel || value.channel?.length === 0) return (
        <>All Payment Methods</>
    )
    return <>
        {value.channel?.length} channels from {value.method?.length} payment methods
    </>
}